import { normalizeMoney } from '@/lib/adapters/common.adapter'
import type { MoneyServerType } from '@/lib/types/common.types'

type LinkClickCpcRaw = {
  count: number
  source: number
  offer_ids: readonly number[] | number[] | null
  user_revenue_cpc_v2: MoneyServerType
}

export type LinkClickCpcItem = {
  count: number
  userRevenueCpc: number
  currency: string
  source: number
  offerIds: number[] | null
}

export const normalizeLinkClickCpcItem = (raw: LinkClickCpcRaw): LinkClickCpcItem => {
  const { amount, currency } = normalizeMoney(raw.user_revenue_cpc_v2)

  return {
    count: raw.count,
    userRevenueCpc: amount,
    currency,
    source: raw.source,
    offerIds: raw.offer_ids ? [...raw.offer_ids] : null,
  }
}

export const serializeLinkClicksCpcPayload = (
  items: LinkClickCpcItem[],
  newCpcValues: number[],
) => ({
  link_clicks_cpc: items.map((item, i) => ({
    count: item.count,
    user_revenue_cpc: Math.round(item.userRevenueCpc * 100),
    source: item.source,
    offer_ids: item.offerIds,
    user_revenue_cpc_new: Math.round((newCpcValues[i] ?? item.userRevenueCpc) * 100),
  })),
})
